//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
SPLM.Annotations.GeometricCharacteristic = Object.freeze({
    "Straightness" : "Straightness", "Flatness" : "Flatness", "Circular" : "Circular", "Cylindrical" : "Cylindrical", "LineProfile" : "LineProfile", "SurfaceProfile" : "SurfaceProfile", "Angular" : "Angular", "Perpendicular" : "Perpendicular", "Parallel" : "Parallel", "Position" : "Position", "Concentric" : "Concentric", "Symmetric" : "Symmetric", "CircularRunout" : "CircularRunout", "TotalRunout" : "TotalRunout", "Last" : "Last"});

SPLM.Annotations.MaterialConditionModifier = Object.freeze({
    "Mmc" : "Mmc", "Lmc" : "Lmc", "Rfs" : "Rfs", "Tangential" : "Tangential", "None" : "None", "Last" : "Last"});

SPLM.Annotations.ToleranceZoneShape = Object.freeze({
    "Planar" : "Planar", "Cylindrical" : "Cylindrical", "Spherical" : "Spherical", "Last" : "Last"});

export default SPLM;